import { errorAction, successfulAction } from '@shared/actions';
import fetchCapacityCheckData from '@services/shops/fetchCapacityCheckData';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import { FETCH_CAPACITY_CHECK } from '@shopDetails/actionTypes';

const type = FETCH_CAPACITY_CHECK;

const fetchCapacityCheck = () => async (dispatch, getState, axios) => {
  const state = getState();
  try {
    const shopId = getShopId(state);
    const { success, data, error } = await fetchCapacityCheckData({
      axios,
      shopId,
    });
    if (success) {
      dispatch(successfulAction({ type, payload: data }));
    } else {
      dispatch(errorAction({ type, error, mute: true }));
    }
  } catch (error) {
    dispatch(errorAction({ type, error, mute: true }));
  }
};

export default fetchCapacityCheck;
